/**
 * Нормализует телефон в формат 79639689069 (11 цифр, без пробелов и +).
 * Удаляет пробелы и +, проверяет, что всего 11 цифр.
 * @returns нормализованный телефон или null, если невалидный
 */
export function normalizePhoneTo11Digits(
  raw: string | null | undefined
): string | null {
  if (raw == null) return null
  const digits = (raw + '').replace(/\D/g, '')
  if (digits.length === 10 && digits[0] === '9') return '7' + digits
  if (digits.length === 11 && digits[0] === '7') return digits
  if (digits.length === 11 && digits[0] === '8') return '7' + digits.slice(1)
  return null
}

export function normalizeRussianPhoneForApi(
  raw: string | null | undefined
): string | null {
  const digits = `${raw ?? ''}`.replace(/\D/g, '')
  if (digits.length === 10 && digits.startsWith('9')) return `7${digits}`
  if (digits.length === 11 && digits.startsWith('7')) return digits
  if (digits.length === 11 && digits.startsWith('8'))
    return `7${digits.slice(1)}`
  return null
}

export function formatRussianPhoneForDisplay(
  raw: string | null | undefined
): string {
  const value = `${raw ?? ''}`
  const digits = value.replace(/\D/g, '')
  if (!digits) return ''
  if (
    digits.length >= 11 &&
    !digits.startsWith('7') &&
    !digits.startsWith('8')
  ) {
    return value
  }

  const localDigits = getRussianLocalDigits(digits).slice(0, 10)
  if (!localDigits) return '+7'

  const area = localDigits.slice(0, 3)
  const prefix = localDigits.slice(3, 6)
  const firstPair = localDigits.slice(6, 8)
  const secondPair = localDigits.slice(8, 10)

  if (localDigits.length <= 3) return `+7 (${area}`
  if (localDigits.length <= 6) return `+7 (${area}) ${prefix}`
  if (localDigits.length <= 8) return `+7 (${area}) ${prefix}-${firstPair}`
  return `+7 (${area}) ${prefix}-${firstPair}-${secondPair}`
}

function getRussianLocalDigits(digits: string): string {
  if (
    digits.length === 1 &&
    (digits.startsWith('7') || digits.startsWith('8'))
  ) {
    return ''
  }

  if (digits.length > 1 && (digits.startsWith('7') || digits.startsWith('8'))) {
    return digits.slice(1)
  }

  return digits
}
